import { render } from "./AccordionElement.vue?vue&type=template&id=04283bae&scoped=true&ts=true&lang=pug"
import script from "./AccordionElement.vue?vue&type=script&lang=ts"
export * from "./AccordionElement.vue?vue&type=script&lang=ts"

import "./AccordionElement.vue?vue&type=style&index=0&id=04283bae&lang=scss&scoped=true"

import exportComponent from "/Users/massimodeluisa/Git/Smart Squad/Esse Group/CMS Admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04283bae"]])

export default __exports__